import React from "react"
import PropTypes from "prop-types"
import PaymentAmountOption from "./payment_amount_option"
import RegistrationsPropTypes from "utils/prop_types"

class PaymentAmountSelect extends React.Component {
  static propTypes = {
    allowMinimumDeposit: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    paymentAmounts: PropTypes.arrayOf(RegistrationsPropTypes.PaymentAmount).isRequired,
    selectedPaymentAmount: RegistrationsPropTypes.PaymentAmount.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      otherAmountCents: null
    }
  }

  render() {
    const { onChange, selectedPaymentAmount } = this.props

    return (
      <div>
        <label className="label h5 pb-1">Select amount to pay</label>
        <div className="mb-2">
          {this.getPaymentAmounts().map(paymentAmount => (
            <PaymentAmountOption
              key={paymentAmount.id}
              onChange={() => onChange(paymentAmount)}
              onOtherAmountChange={this.handleOtherAmountChange}
              paymentAmount={paymentAmount}
              selected={selectedPaymentAmount.id === paymentAmount.id}
            />
          ))}
        </div>
      </div>
    )
  }

  getPaymentAmounts = () => {
    const { allowMinimumDeposit, paymentAmounts } = this.props
    const { amountCents: defaultAmountCents, buttonLabel, currency } = paymentAmounts[0]
    const amountCents = this.state.otherAmountCents || defaultAmountCents

    if (allowMinimumDeposit) {
      return paymentAmounts.concat([
        {
          allowTextInput: true,
          amountCents,
          buttonLabel,
          currency,
          description: "Other",
          id: "other"
        }
      ])
    } else {
      return paymentAmounts
    }
  }

  handleOtherAmountChange = amountCents => {
    const { onChange, selectedPaymentAmount } = this.props
    onChange({ ...selectedPaymentAmount, ...{ amountCents } })
  }
}

export default PaymentAmountSelect
